import { useAdminUpdate } from '@reapitform/hooks'
import { AdminPdfField, AdminPdfFieldPayload } from '../types'

/** Updates a PDF field mapping (`PUT …/versions/{versionRef}/pdf-fields/{pdfFieldRef}`). */
export const useUpdateAdminPdfField = (
  formReferenceID: string,
  versionReferenceID: string,
  pdfFieldReferenceID: string,
) =>
  useAdminUpdate<AdminPdfFieldPayload, AdminPdfField>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/pdf-fields/${pdfFieldReferenceID}`,
    method: 'PUT',
    errorMessage: 'Failed to update the PDF field mapping',
    successMessage: 'PDF field mapping updated',
  })
